exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".md-popover.md-rendering {\n  opacity: 0;\n  -webkit-transition: none !important;\n  transition: none !important;\n}", ""]);

// exports
